import type { DeleteCookieProps } from "./utils/deleteCookie";
import { deleteCookie } from "./utils/deleteCookie";
import type { GetCookieProps } from "./utils/getCookie";
import { getCookie } from "./utils/getCookie";
import type { SetCookieProps } from "./utils/setCookie";
import { setCookie } from "./utils/setCookie";

export const LEGACY_FONT_STYLE_KEY = "hlwFont";
export const COOKIE_KEY_FONT_STYLE = "hlwFontStyle";

export type DeleteCookieFontStyleProps = Omit<DeleteCookieProps, "key">;

export const deleteCookieFontStyle = ({
  cookies,
}: DeleteCookieFontStyleProps = {}) =>
  deleteCookie({ key: COOKIE_KEY_FONT_STYLE, cookies });

export type GetCookieFontStyleProps = Omit<GetCookieProps, "key">;

export const getCookieFontStyle = ({
  cookies,
  schema,
}: GetCookieFontStyleProps = {}) =>
  getCookie({ key: COOKIE_KEY_FONT_STYLE, cookies, schema });

export type SetCookieFontStyleProps = Omit<SetCookieProps, "key">;

export const setCookieFontStyle = ({
  cookies,
  value,
  domain,
  options,
}: SetCookieFontStyleProps) =>
  setCookie({
    key: COOKIE_KEY_FONT_STYLE,
    cookies,
    value,
    domain,
    options,
  });
